import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { TIME_PICKER_FIELD_PREFIX } from '../../../../../../../common/ui/constants.tsx';
import { DEFAULT_START_HOUR, DEFAULT_END_HOUR } from './constants';
import { EndTime } from './end';
import messages from './messages';
import { StartTime } from './start';
import type { Props } from './types';

export const defaultWorkHours = {
	start: DEFAULT_START_HOUR,
	end: DEFAULT_END_HOUR,
} as const;

const ConnectedTimePickersView = ({
	intl: { formatMessage },
	day,
	fieldId,
	defaultValue = defaultWorkHours,
	isDisabled,
}: Props) => {
	const fieldIdPrefix = `${TIME_PICKER_FIELD_PREFIX}${day}`;
	return (
		<Inline>
			<TimePickerWrapper>
				<StartTime
					day={day}
					fieldIdPrefix={fieldIdPrefix}
					fieldId={fieldId}
					defaultValue={defaultValue.start}
					isDisabled={isDisabled}
				/>
			</TimePickerWrapper>
			<Box xcss={spacedStyles}>{formatMessage(messages.to)}</Box>
			<TimePickerWrapper>
				<EndTime
					day={day}
					fieldIdPrefix={fieldIdPrefix}
					fieldId={fieldId}
					defaultValue={defaultValue.end}
					isDisabled={isDisabled}
				/>
			</TimePickerWrapper>
		</Inline>
	);
};

export const ConnectedTimePickers = injectIntl(ConnectedTimePickersView);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Inline = styled.div({
	display: 'flex',
	flex: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TimePickerWrapper = styled.div({
	flex: 1,
});

const spacedStyles = xcss({
	paddingTop: 'space.100',
	margin: 'space.100',
});
